const PbxxRecord = require('../pbxx_record')

module.exports = class CampaignSpendingSummaries extends PbxxRecord {
  static get class_name() {
    return 'CampaignSpendingSummaries'
  }
}
